export const response = {
  error: (res, message) => {
    res.status(500).send({
      message,
    });
  },
  badRequest: (res, message) => {
    res.status(400).send({
      message,
    });
  },
  unauthorized: (res) => {
    res.status(401).send({
      message: 'Não autorizado.',
    });
  },
  forbidden: (res) => {
    res.status(403).send({
      message: 'Sem permissão.',
    });
  },
  notFound: (res, message) => {
    res.status(404).json({
      message,
    });
  },
  conflict: (res, message) => {
    res.status(409).json({
      message,
    });
  },
  ok: (res, data) => {
    res.status(200).json(data);
  },
};
